import React from 'react';
import { findDOMNode } from 'react-dom';
import { Upload, Progress, Icon, Badge, Modal, Pagination, Button } from 'antd';
import _ from 'lodash';
import SvgIcon from 'SvgIcon';

if (process.env.__CLIENT__ === true) {
  require('./PictureBook.less')
}
export default class PictureBook extends React.Component {
  constructor(props) {
    super(props);
    if (props.cStyle) {
      try {
        config = JSON.parse(props.cStyle);
      } catch (e) { }
    }
    this.state = {
      fileList: [],
      fileType: props.fileType || 'img',
      bill2ReferKeyFieldMap: props.bill2ReferKeyFieldMap || {},
      readOnly: props.readOnly,
      percent: 0,
      showModal: false,
      picIndex: 0,
      focus: props.focus,
    };
    this.DocumentServerAddress = 'https://oivs4lxfc.bkt.clouddn.com';
    this.uploading = false;
    var proxy = cb.rest.DynamicProxy.create({
      getFileServerUrl: {
        url: '/pub/fileupload/getFileServerUrl',
        method: 'GET',
        options: { token: true }
      }
    });
    proxy.getFileServerUrl({}, function (err, result) {
      if (!err)
        this.DocumentServerAddress = result;
    }, this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.model) {
      if (!this.props.model) {
        nextProps.model.addListener(this);
        // this.setValue(nextProps.model.getValue());
      } else {
        return;
      }
    } else {
      let bill2ReferKeyFieldMap = nextProps.bill2ReferKeyFieldMap || this.state.bill2ReferKeyFieldMap;
      let fileList = [];
      if (this.props.model) {
        this.props.model.removeListener(this);
        if (nextProps.dataSource)
          fileList = this.transferBill2Refer(nextProps.dataSource, bill2ReferKeyFieldMap);
        this.setState({
          fileList,
          bill2ReferKeyFieldMap,
          focus: nextProps.focus
        });
      } else {
        if (nextProps.dataSource)
          fileList = this.transferBill2Refer(nextProps.dataSource, bill2ReferKeyFieldMap);
        this.setState({
          fileList,
          bill2ReferKeyFieldMap,
          readOnly: nextProps.readOnly,
          focus: nextProps.focus,
        });
      }
    }
  }
  componentDidMount() {
    if (this.props.model)
      this.props.model.addListener(this);
    else {
      let { dataSource, bill2ReferKeyFieldMap, readOnly } = this.props;
      if (dataSource && bill2ReferKeyFieldMap) {
        let fileList = this.transferBill2Refer(dataSource, bill2ReferKeyFieldMap);
        this.setState({ fileList, bill2ReferKeyFieldMap, readOnly })
      }
    }
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
  }
  handleBodyClick = (e) => {
    if (this.contains(this.refs.div, e.target)) return;
    if (e && e.target && cb.dom(findDOMNode(e.target)).parents('.picture-book-modal').length) return;
    document.body.removeEventListener('click', this.handleBodyClick);
    this.setState({
      focus: false
    });
    if (this.props.model)
      this.props.model.execute('blur');
  }
  contains = (elem, target) => {
    if (elem === target)
        return true;
    if (!elem || !elem.children.length)
        return false;
    for (var i = 0, len = elem.children.length; i < len; i++) {
        if (this.contains(elem.children[i], target))
            return true;
    }
    return false;
}
  setListenerState(params, propertyName) {
    let showValue = params.showValue;
    if (showValue ) {
      if(showValue.length > 0)
        params.fileList = this.transferBill2Refer(showValue, params.bill2ReferKeyFieldMap);
      else
        params.fileList = [];
    }
    this.setState(params);
  }
  setValue(value) {
    const fileList = this.transferBill2Refer(value, this.state.bill2ReferKeyFieldMap);
    this.setState({ fileList });
  }
  transferBill2Refer = (value, bill2ReferKeyFieldMap) => {
    if (!value) return [];
    if (cb.utils.isEmptyObject(bill2ReferKeyFieldMap)) return value;
    let fileList = this.state.fileList;
    var newValue = [];
    value.forEach(function (item, index) {
      if(item._status=="Delete") return
      var referItem = {};
      for (var billKey in bill2ReferKeyFieldMap)
        referItem[bill2ReferKeyFieldMap[billKey]] = item[billKey];
      if (fileList[index]) {
        if (fileList[index].name == referItem.name && fileList[index].size == referItem.size) {
          referItem.id = fileList[index].id;
        } else {
          let i = _.findIndex(fileList, { "name": referItem.name, "size": referItem.size });
          if (i != -1) referItem.id = fileList[i].id;
        }
      }
      newValue.push(referItem);
    });
    return newValue;
  };
  /*上传改变事件*/
  _fielUploadOnChange = (info) => {
    let { fileList, replaceIndex, onReplace, bill2ReferKeyFieldMap } = this.state;
    let num = _.findIndex(fileList, { 'id': info.file.uid });
    /*上传中状态*/
    if (info.file.status === 'uploading') {
      /*更新上传文件进度*/
      if (!info.file.percent) {
        cb.utils.loadingControl.end();
        this.uploading = false;
        fileList[num].percent = 100;
      } else {
        fileList[num].percent = info.file.percent;
      }
      fileList[num].size = info.file.size;
      this.setState({
        fileList,
        percent: info.file.percent
      });
    }
    /*上传完成状态*/
    if (info.file.status === 'done') {
      if (info.file.response.code == 200) {
        /*上传完成，更新上传文件信息*/
        fileList[num].address = this.DocumentServerAddress + info.file.response.data;
        this.setState({
          fileList,
          percent: 0
        });

        // cb.utils.alert(`${info.file.name} 上传成功！`, 'success');
        cb.utils.loadingControl.end();
        this.uploading = false;
        if (this.props.modelType == 'SimpleModel') {
          this.props.model.setValue(this.DocumentServerAddress + info.file.response.data, true);
          return
        }
        if (onReplace) {
          if (this.props.model) {
            let cellValues = [];
            for (var key in bill2ReferKeyFieldMap) {
              let newKey = bill2ReferKeyFieldMap[key];
              cellValues.push({
                index: replaceIndex,
                cellName: key,
                cellValue: fileList[replaceIndex][newKey]
              })
            }
            if (this.props.model)
              this.props.model.setCellValues(cellValues);
          }
          this.setState({
            onReplace: false
          })
        } else {
          if (this.props.model) {
            let bSet = true;
            fileList.map(item => {
              if (cb.utils.isEmpty(item.address)) bSet = false;
            });
            if (bSet) this.props.model.setValue(fileList, true);
          }
        }

      } else {
        /*上传失败删除上传文件*/
        cb.utils.loadingControl.end();
        this.uploading = false;
        fileList.pop();
        this.setState({
          fileList,
          percent: 0
        });
        cb.utils.alert(`${info.file.name} 上传失败！${info.file.response.code} : ${info.file.response.message}`, 'error');
      }
    }
    /*上传出错状态*/
    if (info.file.status === 'error') {
      cb.utils.alert(`${info.file.name} 上传失败！${info.file.response.code} : ${info.file.response.message}`, 'error');
    }
  }
  /*显示已上传文件/图片的列表*/
  _fileListControl = (fileType) => {
    if (this.state.fileList.length == 0 && this.state.readOnly) {
      return <div className="upload-nodata"><Icon type={fileType == "file" ? "noFile" : "noPic"} /><span>{fileType == "file" ? "暂无附件~" : "暂无图片~"}</span></div>
    }
    return <FileList arrowImg={this._arrowImg} DelFile={this._DelFile} colCount={this.state.colCount} fileType={fileType} fileList={this.state.fileList} readOnly={this.state.readOnly} mode={this.state.mode} />
  }
  /*删除已上传文件*/
  _DelFile = (index) => {
    if (this.props.model)
      this.props.model.deleteItem(index);
  }
  /*上传前事件*/
  _beforeUpload = (file, uploadFileList) => {
    if (this.props.modelType == 'SimpleModel' && this.state.fileList && this.state.fileList.length > 0) {
      cb.utils.alert('超出上传限制，请替换或删除后重新上传！', 'error');
      return;
    }
    cb.utils.loadingControl.start();
    if (file.size > 1048576) {
      cb.utils.alert('上传大小超出限制，请重新上传！', 'error');
      this.uploading = false;
      cb.utils.loadingControl.end();
      return false;
    }
    let accept = "png,jpg,jpeg,bmp";
    accept = accept.split(',');
    let inAccept = false;
    accept.map(item => {
      if (file.name && file.name.toLowerCase().split(item).length > 1)
        inAccept = true;
    });
    if (!inAccept) {
      cb.utils.alert('选择文件格式不正确，请重新选择', 'error');
      this.uploading = false;
      cb.utils.loadingControl.end();
      return false;
    }
    if (!this.uploading) {
      this.uploading = true;
      // cb.utils.alert('上传中~请稍后！', 'success');
    }
    let { fileList, onReplace, replaceIndex } = this.state;
    if (onReplace)
      fileList[replaceIndex].id = file.uid;
    else
      fileList.push({ 'percent': file.percent, 'name': file.name, 'id': file.uid, 'type': file.type });
    this.setState({ fileList });
  }
  onOk = () => {
    this.setState({ showModal: false });
    if (this.props.model && this.props.inTable) this.props.model.execute('blur');
  }
  onCancel = () => {
    this.setState({ showModal: false });
    if (this.props.model && this.props.inTable) this.props.model.execute('blur');
  }
  onBigCancel = () => {
    this.setState({ showDetailModal: false, picIndex: 0 });
  }
  showPicModel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.onClick();
    this.setState({
      showModal: true
    })
  }
  onOpenDetail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ showDetailModal: true });
  }
  onDelete = (e) => {
    this.onClick();
    e.preventDefault();
    e.stopPropagation();
    const fileList = this.state.fileList;
    let indexes = [];
    fileList.map((file, index) => {
      indexes.push(index);
    });
    if (this.props.model) {
      this.props.model.deleteItems(indexes)
    } else {
      if (this.props.onDelete)
        this.props.onDelete(indexes);
    }
  }
  onPicDelete = (e, index) => {
    if (this.props.modelType == 'SimpleModel') {
      if(this.props.model)
        this.props.model.setValue(null);
      else if(this.props.onDelete)
        this.props.onDelete();
      return;
    }
    if (this.props.model)
      this.props.model.deleteItem(index)
  }
  onReplace = (e, index) => {
    this.setState({
      onReplace: true,
      replaceIndex: index
    });
  }
  onClick = () => {
    if (this.props.onClick)
      this.props.onClick();
  }
  onLeftClick = () => {
    if (this.state.picIndex == 0) return;
    this.setState({
      picIndex: this.state.picIndex - 1
    });
  }
  onRightClick = () => {
    if (this.state.picIndex == this.state.fileList.length - 1) return;
    this.setState({
      picIndex: this.state.picIndex + 1
    });
  }
  onThumbnailClick = (e, index) => {
    this.setState({
      picIndex: index
    });
  }
  _getControl = () => {
    const { fileList } = this.state;
    let readOnly = false, count = fileList.length;
    if (this.state.mode == 'browse' || this.state.readOnly) readOnly = true;
    let control = null, style = {};
    if (count == 0) {/*无数据*/
      if (readOnly) {
        control = (
          <Badge count={count}>
            <div className="pictureBook readOnly">
              <SvgIcon type="zanwushangpinxiangcetupian" />
              <div className='pictureRow'></div>

            </div>
          </Badge>
        )
      } else {
        let tempControl = (
          <div className="pictureBook " onClick={this.showPicModel}>
            <div className='pictureRow'></div>
            <SvgIcon type="shangchuantupian" />
            <p>上传图片</p>
          </div>
        )
        control = tempControl;
        // control = this.getUploadControl(tempControl);
      }
    } else {/*存在上传数据*/
      let src = this.props.modelType == 'SimpleModel' ? fileList : fileList[0].address;
      if (readOnly) {
        control = (
          <div className="pictureBook " onClick={this.onClick}>
            <div className="pictureRow"></div>
            <div className='pictureImg'><img src={src} /></div>
            {
              this.props.inTable ? null :
                <div className="fileBtn">
                  <a onClick={this.onOpenDetail} className={'search'}>
                    <Icon type="search" />
                  </a>
                </div>
            }
          </div>
        )
        if (!this.props.inTable)
          control = <Badge count={count}>{control}</Badge>
      } else {
        let tempControl = (
          <div className="pictureBook " onClick={this.onClick}>
            <div className='pictureRow'></div>
            <div className='pictureImg'><img onClick={this.showPicModel} src={src} /></div>
            {
              this.props.inTable ? null :
                <div className="fileBtn">
                  <a className={'upload'}>
                    <Icon type="uploadImg" />
                  </a>
                  <a onClick={this.onOpenDetail} className={'search'}>
                    <Icon type="search" />
                  </a>
                  <a onClick={this.onDelete} className={'delete'}>
                    <Icon type="delete" />
                  </a>
                </div>
            }
            <div className='Progress'>
              {(this.state.percent && this.state.percent != 100) ?
                <Progress percent={this.state.percent} strokeWidth={5} />
                :
                null}
            </div>
          </div>
        )
        if (!this.props.inTable)
          tempControl = <Badge count={count}>{tempControl}</Badge>
        control = this.getUploadControl(tempControl);
      }
    }
    return control
  }
  getModalControl = (uploadControl) => {
    const { fileList, bPaginationChange } = this.state;
    let control = [];
    if (this.props.modelType == 'SimpleModel') {
      if (fileList && fileList.length > 0)
        control.push(
          <div className="list-col">
            <div className="pictureBook">
              <div className='pictureImg'><img src={fileList} /></div>
              <div className="fileBtn">
                {this.getUploadControl(<a onClick={e => this.onReplace(e)} className={'replace'}><SvgIcon type="tihuan" /></a>)}
                <a onClick={e => this.onPicDelete(e)} className={'delete'}>
                  <Icon type="delete" />
                </a>
              </div>
            </div>
          </div>
        )
    } else {
      let len = fileList.length;
      for (var i = 0; i < len; i++) {
        let j = i;
        let buttonControl = (
          <a onClick={e => this.onReplace(e, j)} className={'replace'}><SvgIcon type="tihuan" /></a>
        )
        let tempControl = this.getUploadControl(buttonControl);
        control.push(
          <div className="list-col">
            <div className="pictureBook">
              <div className='pictureImg'><img src={fileList[i].address} /></div>
              <div className="fileBtn">
                {tempControl}
                <a onClick={e => this.onPicDelete(e, j)} className={'delete'}>
                  <Icon type="delete" />
                </a>
              </div>
            </div>
          </div>
        )
      }
    }
    return (
      <div className="pictureBook-list">
        {this.state.readOnly ? "" : uploadControl}
        <div className="pictureBook-list-title">（最大1M，支持格式：jpg、bmp、png、jpeg，700*700 以上的图片可以在商品详情页主图提供图片放大功能）</div>
        <div className="list-row">
          {control}
        </div>
      </div>
    )
  }
  getBigModalControl = () => {
    const { fileList, picIndex } = this.state;
    let imgUrl = null, left = null, right = null, rightControls = [];
    let len = fileList.length - 1;
    if (fileList[picIndex]) imgUrl = fileList[picIndex].address;
    if (picIndex != 0)
      left = <a className="pic-left" onClick={this.onLeftClick}><Icon type="left" /></a>
    if (picIndex != len)
      right = <a className="pic-right" onClick={this.onRightClick}><Icon type="right" /></a>
    fileList.forEach((file, index) => {
      if (fileList[index])
        rightControls.push(
          <span onClick={e => this.onThumbnailClick(e, index)} className={"right-img " + (index == picIndex ? 'active' : '')}><img src={file.address} /></span>
        )
    });
    return (
      <div className="bigmodal-container">
        <span className="tips">
          <span className="pre-index">{picIndex + 1}</span>/
          <span className="aft-index">{len + 1}</span>
        </span>
        <div className='picture-big'>
          {left}{imgUrl ? <img src={imgUrl} /> : null}{right}
        </div>
        <div className="pictrue-right">{rightControls}</div>
      </div>
    )
  }
  getUploadControl = (control) => {
    let action = '/upload?token=' + cb.rest.AppContext.token;
    let accept = '';
    if (this.state.fileType == 'img') accept = 'image/jpeg,image/png,image/x-ms-bmp';
    return (
      <Upload
        showUploadList={false}
        action={action}
        onChange={this._fielUploadOnChange}
        multiple={true}
        accept={accept}
        beforeUpload={this._beforeUpload}
      >
        {control}
      </Upload>
    )
  }
  render() {
    let control = this._getControl();
    let buttonControl = (
      <Button key="upload" onClick={this.handleModify}>
        {/* <SvgIcon className="plus-copy" type="export" /> */}
        上传图片
        </Button>
    )
    let uploadControl = this.getUploadControl(buttonControl);
    let modalControl = this.getModalControl(uploadControl);
    let bigModalControl = this.getBigModalControl();
    let modelTitle = this.props.inTable ? this.props.cShowCaption : '图册';
    const title = (
      <div className="model-header">
        <div className="modelTitle">{modelTitle || '图册'}</div>
      </div>
    );
    if (this.state.focus && this.props.inTable)
      document.body.addEventListener('click', this.handleBodyClick);
    return (
      <div className='upload-picture-book clearfix' ref="div">
        {control}
        <Modal title={title} width={750} visible={this.state.showModal} className="picture-book-modal"
          onOk={this.onOk} onCancel={this.onCancel} okText="确认" cancelText="取消" maskClosable={false}
        >
          {modalControl}
        </Modal>
        <Modal title="查看大图" width={850} visible={this.state.showDetailModal} className="picture-big-modal"
          footer={null} maskClosable={false} onCancel={this.onBigCancel}
        >
          {bigModalControl}
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/picturebook/PictureBook.jsx